import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Platform } from '@ionic/angular';
import { NativeService } from '../../../service/native.service';
import { CommonService } from '../../../service/common.service';
import { MessageclientService } from '../../../service/messageclient.service';
import { HttpCustomerService } from '../../../service/httpcustomer.service';
import { BaseModal } from '../../../../src/model/base';
import { GridBaseCase } from '../grid/grid.base.case';
import { BaseCase } from 'src/app/basecase';
import { WebParameterContext,AppInfo,AgentConfigParams } from '../../../model/common';
import { AppVersion } from '@ionic-native/app-version/ngx';
import { SysAccount} from '../../../model/sys.account';
import {File} from '@ionic-native/file/ngx';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import {WxjssdkService} from 'src/service/wxjssdk.service';
import {IndexdbService} from 'src/service/indexdb.service';
declare var app;
declare var wx;
@Component({
  selector: 'app-personal-center',
  templateUrl: './personal-center.component.html',
  styleUrls: ['./personal-center.component.scss']
})
export class PersonalCenterComponent extends GridBaseCase implements AfterViewInit{
  type: string = null;
  obj:any={"a_Password":null,"a_Password2":null,"a_Password3":null};
  errorPassword = false;
  year:Date = new Date();
  storeName:any="";
  versionCode:any = "0.0.0";//app版本号
  onlineCall:any="";
  @ViewChild("QRCode") QRCode:ElementRef;
  downloadUrl:any = null;
  gradeCode:string = null;//当前用户等级
  pagecage:AppInfo=null;
  isversion:boolean=false;
  isMobile:boolean = true;//是否移动端默认true
  isPg:boolean = false;//是否pg
  sysuserName:string ="";//登陆人；
  syspic:string="";//图像
  QYWXQRCodestyle:any; // 企业为微信二维码
  constructor(
    private nativeservice: NativeService,
    private router: Router,
    private actRouter: ActivatedRoute,
    private comon: CommonService,
    private msg: MessageclientService,
    private http: HttpCustomerService,
    public base: BaseModal,
    private platform: Platform,
    public basecase: BaseCase,
    public file:File,
    public iab:InAppBrowser,
    private weixin:WxjssdkService,
    private appVersion: AppVersion,
    public indexdb:IndexdbService
  ) {
    super();
    const that =this;
    this.onlineCall = app.ONLINECALL;
    that.sysuserName ="";
    // debugger;
     if(that.comon.GetStorageKey("account")){
      that.sysuserName=that.base.account.DisplayName;
      if(that.base.account.Pic){
        that.syspic = (app.FileUoloadUrl+this.base.account.Pic).replace(app.ImagePlaceholder,app.SmallImageType);
      }

     };
    // console.log(base.account.DisplayName,"base.account.DisplayName");
    const picUrl = localStorage.getItem("pic_"+this.base.account.Id);
    if (picUrl) {
      this.base.account.Pic = picUrl.replace(app.ImagePlaceholder,app.SmallImageType);
    } else if (!this.base.account.Pic) {
      this.base.account.Pic = "../../../assets/img/avatar/default-head.png";
    }
    this.type = this.actRouter.snapshot.paramMap.get('type');
    if (this.type == 'password') {
      this.basecase.pageTitle = "修改密码";
    } else if (this.type == 'about') {
      this.basecase.pageTitle = "关于我们";
    }
    this.getAppVersion();
    const pgInfo = this.comon.GetStorageKey("pginfo");
    if(pgInfo){
      this.storeName = pgInfo["c_Name"];
    }
    if(!that.platform.is("cordova")){
      that.isMobile=false;
    }else{
      this.UpdateVersionLoad();//版本更新
    }
     
    this.gradeCode = this.comon.GetAccount.GradeCode || "";
    that.base.account.Roles.forEach(role=>{
        if(role.Code=="1002"){
          that.isPg = true;
        }
    });
    
  }
  /**
 * 版本更新
 */
UpdateVersionLoad(){
  const that =this;
  that.base.account = that.comon.GetStorageKey("account");
  this.http.GetAppPackage().then(data=>{
    // console.log("1008611");
    let pagecage:AppInfo = data.Status.Datas[0];
   
    if(!pagecage.Url){
      console.log("配置有误");
      return;
    }
    that.pagecage = pagecage;
    that.isversion=true;
  }).catch(err=>{
    console.log(err);
  });
}
/**
 * 强制更新App
 */
GetUpdateLoad(){
  const that =this;
  if(that.isversion){
    if(that.pagecage.AndroidOrIos){//表示IOS
      let url=app.WEBURL+"/"+that.pagecage.webUrl;
      that.iab.create(url);
    }else{
      let androidurl=app.WEBURL+"/"+that.pagecage.Url;
      that.nativeservice.downloadApp(androidurl);
    }
  }else{
    that.msg.Show("暂无新版本");
  }

}
EventClose(){
  const that=this;
  that.msg.Confirm("确定关闭当前程序吗?","暂不关闭","关闭","",false).then(res=>{
    if(res){
      localStorage.clear();
      sessionStorage.clear();
      let out:SysAccount=new SysAccount();
        that.base.account = out;
        that.base.subMenus=[];
        localStorage.setItem("account",JSON.stringify(out));
        that.http.GetLoginOut().then(res=>{
          console.log(res,"退出登录成功");

        }).catch(err=>{
          console.log(err,"退出登录失败");
        });
        if(that.comon.IsWeixinBrowser){
          that.comon.CloseWeixin();
        }else{
          that.comon.Go('/login');
        }
      // sessionStorage.removeItem("_imei");
      
    }
  })
}
/**
 * 打开外部链接
 */
linkEvent(){
  this.iab.create("https://nestle.aven90.cn/app/index.php?i=3&c=entry&eid=307");
}
IndexDb(){
  const that=this;
  let student=[
    { 
      id:1004, 
      name:"张三", 
      age:21,
      sex:"男"
    },{ 
      id:1005, 
      name:"李四", 
      age:20,
      sex:"女"
    },{ 
      id:1006, 
      name:"王五", 
      age:19,
      sex:"女"
    }
  ];
  that.indexdb.Add("person",student).then(res=>{
    console.log(res);
  }).catch(err=>{
    console.log(err);
  });

  
}
query(){
  const that=this;
  that.indexdb.queryAll("sysTab").then(res=>{
    console.log(res);
  }).catch(err=>{
    console.log(err);
  });

}
/**
 * 版本更新
 */
  UpdateVersion(){
    const that =this;
    that.base.account = that.comon.GetStorageKey("account");
    this.http.GetAppPackage().then(data=>{
      // console.log("1008611");
      let pagecage:AppInfo = data.Status.Datas[0];
     
      if(!pagecage.Url){
        console.log("配置有误");
        return;
      }
      if(pagecage.IsUpdate){
        that.msg.Alert(pagecage.Memo,"更新提示","立即更新",false).then(fail=>{
          if(fail){
            that.base.account.AppVersion =pagecage.AppVersion;
            // localStorage.setItem("account",JSON.stringify(that.base.account));
            console.log(pagecage);
            if(pagecage.AndroidOrIos){//表示IOS
              let url=app.WEBURL+"/"+pagecage.webUrl;
              that.iab.create(url);
            }else{
              let androidurl=app.WEBURL+"/"+pagecage.Url;
              that.nativeservice.downloadApp(androidurl);
            }
          }
        });
      }else{
        that.msg.Confirm(pagecage.Memo,"暂不更新","立即更新").then(fail=>{
          if(fail){
            that.base.account.AppVersion =pagecage.AppVersion;
            // localStorage.setItem("account",JSON.stringify(that.base.account));
            console.log(pagecage);
         
            if(pagecage.AndroidOrIos){//表示IOS
              let url=app.WEBURL+"/"+pagecage.webUrl;
              that.iab.create(url);
            }else{
              let androidurl=app.WEBURL+"/"+pagecage.Url;
              that.nativeservice.downloadApp(androidurl);
            }
          }
        });
      };
    }).catch(err=>{
      console.log(err);
    });
  }
  /**
   * 获取app版本号
   */
  getAppVersion(){
    const that = this;
    if(that.platform.is("cordova")){
      if(that.platform.is("android")){
        that.appVersion.getVersionNumber().then(number=>{
          that.versionCode = number;
          console.log(number);
        }).catch(err=>{
          console.log(err);
        });
      }else{
        that.appVersion.getVersionNumber().then(num=>{
          console.log(num);
          that.versionCode = num;
        }).catch(err=>{
          console.log(err);
        });
      }
     
    }
  }
  /**
   * 下载日志文件
   */
  downrizhi(){
    const that =this;
          if(that.platform.is("cordova")){
            that.comon.GeAllFieldsList().then(data=>{
              that.msg.Show("日志同步成功");
              console.log(data,"日志");
              if(data.length>0){
                data.forEach(fied=>{
                 if(fied.isFile){
                    let index:number= fied.name.lastIndexOf(".")+1;
                    let filesname = fied.name.substring(index,fied.name.length);//获取文件名称
                    if(filesname=="txt"){//获取过滤txt文件
                        let parms={};
                        parms["storeId"]=null;
                        parms["TBProductBrand_ID"]=that.comon.GetAccount.Id;//类型ID
                        parms["SavePath"]="uploads/AppError/"+that.comon.GetAccount.LoginName;//分类类型
                        that.nativeservice.UploadFile(fied.nativeURL,parms,"text/plain").then(result=>{
                          let fileIdex:number = fied.name.lastIndexOf("/")+1;
                          let fileName:any = fied.name.substring(fileIdex,fied.name.length);//获取文件名称
                          let fileUrl:any=fied.nativeURL.substring(0,fied.nativeURL.lastIndexOf("/"));
                          that.file.removeFile(fileUrl,fileName).then(data=>{
                            console.log(data,"日志删除成功");
                          }).catch(err=>{
                              console.log(err,"日志删除失败");
                          });
                      }).catch(err=>{
                        that.msg.Show("暂无日志");
                      });
                    }
                 }
                });
              }else{
                that.msg.Show("暂无日志");
              }
            }).catch(err=>{
              console.log(err);
            }); 
          }else{
            that.msg.Show("手机端可用");
          }
          // that.nativeservice.UploadFile(tempDirectory,parms,"text/plain").then(result=>{
          //   load.dismiss();
          //   that.msg.Show("日志已同步成功");
          // }).catch(err=>{
          //   load.dismiss();
          //   that.msg.Show("暂无日志");
          // });
  }
  /**
   * 清空系统日志
   */
  Clearrizhi(){
    const that =this;
          // if(that.platform.is("cordova")){
          //   let tempDirectory:any=that.file.tempDirectory;//默认ios临时目录
          //       if(that.platform.is("android")){
          //         tempDirectory=that.file.externalCacheDirectory;//android
          //       }
          //       tempDirectory=tempDirectory;//文件路径
          //   let fileName:any = that.comon.getNow+".txt";//文件名称
          //   that.msg.Confirm("确定清空系统日志吗？","取消","确认").then(result=>{
          //     if(result){
          //       that.file.removeFile(tempDirectory,fileName).then(fields=>{
          //          that.msg.Show("操作成功");
          //       }).catch(error=>{
          //         that.msg.Show("当前没有需要清理的日志文件");
          //       });
          //     }
          //   });
          // }else{
          //   that.msg.Show("手机端可用");
          // }

          if(that.platform.is("cordova")){
            that.comon.GeAllFieldsList().then(data=>{
              console.log(data,"日志");
              that.msg.Show("清除成功");
              if(data.length>0){
                data.forEach(fied=>{
                 if(fied.isFile){
                    let index:number= fied.name.lastIndexOf(".")+1;
                    let filesname = fied.name.substring(index,fied.name.length);//获取文件名称
                    if(filesname=="txt"){//获取过滤txt文件
                      let tempDirectory:any=that.file.tempDirectory;//默认ios临时目录
                      if(that.platform.is("android")){
                        tempDirectory=that.file.externalCacheDirectory;//android
                      }    
                        that.file.removeFile(tempDirectory,fied.name).then(fdata=>{
                          console.log(fdata);
                          
                        }).catch(err=>{
                          console.log(err);
                        });
                    }
                 }
                });
              }else{
                that.msg.Show("暂无缓存");
              }
            }).catch(err=>{
              console.log(err);
            }); 
          }else{
            that.msg.Confirm("确定清空缓存吗？清空后必须重新登录").then(data=>{
              if(data){
                that.LoginOut();
                that.comon.removeItem(new Array<string>("token","pginfo","tbstore","setMap","pgindata","pgondate","startDate","enddate","clock","clockOut","backurl","exp","menus","readCount","timediffer","badge_"+that.comon.GetAccount.Id,"ISCLOSE","INFO","loginError","INFOBAGE","account"));
                // sessionStorage.clear();
                let out:SysAccount=new SysAccount();
                  // that.base.account = out;
                  that.base.subMenus=[];
                  // localStorage.setItem("account",JSON.stringify(out));
                  // localStorage.clear();
                   that.comon.Go('/login',true);
              }
            });
          }


  }

  /**
     * 跳转明细
     */
  GetDetail() {
    this.comon.setHistoryUrl();
    this.comon.Go("/tabs/picture");
  }
  GetCall(number: string) {
    this.nativeservice.GetCallPhone(app.ONLINECALL).then((data) => {
      console.log(data);
    }).catch((error) => {
      console.log(error);
    });
  }
  GetSendMsg(phone: string) {
    // this.router.navigate(['tabs/calendar']);
    this.nativeservice.GetSendMsg(phone, "系统消息");
  }
  next(url) {
    if (url) {
      console.log(url);
      this.comon.Go(url);
    } else {
      // this.msg.Show("暂未开通", "middle");
    }
  }

  signOut() {
    let that = this;
    that.msg.Confirm("确定注销当前帐号吗？").then(data=>{
      if(data){
        that.LoginOut();
        localStorage.clear();
        sessionStorage.clear();
        let out:SysAccount=new SysAccount();
          that.base.account = out;
          that.base.subMenus=[];
          localStorage.setItem("account",JSON.stringify(out));
           that.comon.Go('/login');
      }
    });
    // that.comon.LoginOut();
  }
  LoginOut(){
    let that = this;
    let obj:any={};
    let body = new WebParameterContext();
    body.ConfigName = "getloginout";
    body.OpType = "GET";
    body.ConfigType = "VIEW";
    body.Client.PageName = "LoginOut";
    body.Client.ApiType = "Content";
    body.Client.Name = "LoginOut";
    body.Client.Type = "get";
    body.Client.ClientType = 2;
    obj.ID=that.comon.GetAccount.Id;//获取当前ID
    body.RequestBody = JSON.stringify(obj);
    that.http.post(app.LOGINOUTURL, body);
  }
  exitApp() {
    if (this.platform.is("cordova")) {
      this.comon.exitApp();
    } else {
      this.comon.LoginOut();
    }
  }
  clearlock() {
    let that = this;
    that.msg.Confirm("确定切换当前帐号吗？").then(data=>{
      if(data){
        that.comon.removeItem(new Array<string>("token","pginfo","tbstore","setMap","pgindata","pgondate","startDate","enddate","clock","clockOut","backurl","exp","menus","readCount","timediffer","badge_"+that.comon.GetAccount.Id,"ISCLOSE","INFO","loginError","INFOBAGE"));
        sessionStorage.removeItem("_imei");
        that.http.GetLoginOut().then(res=>{
          console.log(res,"退出登录成功");

        }).catch(err=>{
          console.log(err,"退出登录失败");
        });
        let out:SysAccount=new SysAccount();
          that.base.account = out;
          that.base.subMenus=[];
          localStorage.setItem("account",JSON.stringify(out));
           that.comon.Go("/login",true);
      }
    });
  }
  // camare() {
  //   const that = this;
  //   that.nativeservice.GetMuiltPicture().then(data => {
  //     console.log(data);
  //   }).catch(error => {
  //     console.log(error);
  //   });
  // }

  // PasswordChange(){
  //   let that = this;
  //   if(that.newPassword1 && that.newPassword2 &&(that.newPassword1 != that.newPassword2)){
  //     that.errorPassword = true;
  //   }
  // }
  //修改密码
  PasswordEvent(obj) {
    let that = this;
    let body = new WebParameterContext();
    body.ConfigName = "EditePassword";
    body.OpType = "GETEDITE";
    body.ConfigType = "form";
    body.Client.PageName = "my";
    body.Client.ApiType = "Content";
    body.Client.Name = "password";
    body.Client.Type = "edite";
    body.Client.ClientType = 2;
    obj.ID=that.comon.GetAccount.Id;//获取当前ID
    body.RequestBody = JSON.stringify(obj);
    that.msg.Loading("数据请求中...").then(load => {
      that.http.post(app.DEFAULTURL, body).then(
        data => {
          if (data.ResponseMessage.Success) {
            that.msg.Alert("密码修改成功,请重新登录").then((resu)=>{
              if(resu){
                this.comon.LoginOut();
              }
            }).catch(err=>{
              console.log(err);
            });
            load.dismiss();
            
          } else {
            load.dismiss();
            // console.log( data.ResponseMessage.ErrorMessage);
            that.msg.Alert(data.ResponseMessage.ErrorMessage);
          }
        }
      ).catch(error => {
        load.dismiss();
        console.log(error);
        that.msg.Show("服务器异常,请联系管理员");
      });
      load.present();
    }).catch(err=>{
      console.log(err);
    });
    // console.log(obj);

  }


  goWebPage() {
    this.comon.Go('/webpage', { url: app.ONLINESERVICEURL, name: "在线客服" });
  }

  ngAfterViewInit(){
    let that= this;
    if(this.platform.is("ios")){
      that.GetDownLoadAppUrl(1);
    }else{
      that.GetDownLoadAppUrl(2);
    }
  }

  GetDownLoadAppUrl(n){
    let that = this;
    let body = new WebParameterContext();
    body.ConfigName = "GetUrlByType";
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = 1;
    body.Client.PageName = "My";
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    body.RequestBody = JSON.stringify({"type":n});
      that.http.post(app.DEFAULTURL, body).then(
        data => {
          if(data.Status){
            that.downloadUrl = data.Status;
          }
        }
      ).catch(error => {
        console.log(error);
      });
  }

  downloadLink(){
    this.comon.setHistoryUrl();
    this.comon.goQrCode(this.downloadUrl,'a2 iSmart智慧终端门店服务专家',"APP下载");
  }
  //企业微信二维码
  downloadPGLink(){
    let that=this;
    
  //  if(localStorage.getItem("account"))
  //  {
  //    let jsonData=JSON.parse(localStorage.getItem("account"));
  //    if(jsonData&&jsonData["Qrcode"])
  //    {
  //     let _imgurl:any = jsonData["Qrcode"].replace("/placeholder","");
  //     let _url:any=app.WEBURL+"/"+_imgurl;
  //     sessionStorage.setItem("curl","true");
  //     that.comon.goQrCode(_url,"ismycode");
  //    }
  //  }

    // let that = this;
    // localStorage.removeItem("ordermarstID");
    let body = new WebParameterContext();
    body.ConfigName = "SystemUser";
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = 1;
    body.Client.PageName = "ScanCodeSales";
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    let _QYWXId = that.comon.GetAccount.QYWXId;
    let _QYWXIdType = that.comon.GetAccount.QYWXIdType;
    let _QYCode = localStorage.getItem("QYCode");
    if(_QYWXId && _QYWXIdType == '0'){
      body.RequestBody = JSON.stringify({
        QYWXId:_QYWXId,
        QYCode:_QYCode,
        type:1
      });

    }else{
      that.msg.Alert("该二维码已失效，无法找到对应的企业微信号");
      return;
    }
    that.msg.Loading("加载中，请稍后").then(load=>{
      that.http.post(app.DEFAULTURL, body).then(data => {
        load.dismiss();
        if(data.ResponseMessage.Success){
          console.log(data,"结果");
          if(data.Status){
        //     let QYWXQRCode: Array<any> = [];
        //     QYWXQRCode.push(data.Status.QYWXQRCode);
        //      that.weixin.GetWxPreviewImage(data.Status.QYWXQRCode,QYWXQRCode ).then(data=>{
        //        console.log(data)
        //       }).catch(err=>{
        //         //  load.dismiss();
        //         console.log(err,"图片放大888888");
        //         that.msg.Alert(app.ERRORMESSAGE);
        //       });
               that.QYWXQRCodestyle=data.Status.QYWXQRCode;

          // that.iab.create(data.Status.QYWXQRCode);
          //  that.comon.goQrCode(data.Status.QYWXQRCode,'QYWXQRCode',"企业微信二维码");
          that.comon.setHistoryUrl();
         this.comon.Go('/tabs/wechatQrcod/'+this.comon.getNowDatetime,{
            QYWXQRCodestyle: that.QYWXQRCodestyle,
         });
         
          //  that.router.navigate(['/tabs/wechatQrcod/'+"&"+that.comon.getNowDatetime]);
           
          }else{
            that.msg.Alert(app.ERRORMESSAGE);
          }
        }else{
          that.msg.Alert(data.ResponseMessage.ErrorMessage);
        }
      }
    ).catch(error => {
       load.dismiss();
      that.msg.Alert(error.ResponseMessage.ErrorMessage);
      console.log(error);
    });
      load.present();
    }).catch(err=>{
      console.log(err);
    })
     
   
  }
  /**
   * PG二维码
   */
  OwnLink(){
    const that=this;
    console.log("1008611");

    //  if(that.comon.GetAccount){
       console.log("存储值显示")
      console.log(that.comon.GetAccount);
      //  let jsonData=JSON.parse(localStorage.getItem("account"));
       let jsonData = that.comon.GetAccount;
       console.log("有存储二维码");
       console.log(jsonData);
       console.log("新的二维码")
       console.log(jsonData.Qrcode);
      //  console.log(jsonData["qrcode"]);
      //  if(jsonData&&jsonData.Qrcode){
      //   that.comon.setHistoryUrl();
      //   let _imgurl:any = jsonData.Qrcode.replace("/placeholder","");
      //   console.log(_imgurl);
      //   let _url:any=app.WEBURL+"/"+_imgurl;
      //   sessionStorage.setItem("curl","true");
      //   that.comon.goQrCodeone(_url,"ismycode");
      //  }else{
        //  that.msg.Alert("您的门店二维码不存在,请联系管理员");
         that.SNCInfo1();
      //  }
    //  }else{
    //   that.msg.Alert("您的门店二维码不存在,请联系管理员");
    // }
  }
  /**
   * 会员注册二维码
   */
  MemberQRcodeLink(){
    this.comon.setHistoryUrl();
    this.comon.goQrCode(this.downloadUrl,'扫码下载APP',"APP下载");
  }
  /**
   * 自定义转发到会话
   */
  BtnAppMessage(){
    const that=this;
    if(that.comon.IsWeixinBrowser){//如果是微信
      let _config:any={
        title: '自定义转发到会话', // 分享标题
        desc: '自定义转发到会话描述'// 分享描述
      };
      that.weixin.GetshareAppMessage(_config).then(data=>{
        that.msg.Alert("转发成功");

      }).catch(err=>{
        that.msg.Alert(err.ResponseMessage.ErrorMessage);
      });
    }
  }
  /**
   * 自定义转发到微信
   */
  BtnAppweixin(){
    const that=this;
    if(that.comon.IsWeixinBrowser){//如果是微信
        let _config:any={
          title: '自定义转发到微信', // 分享标题
          desc: '自定义转发到微信描述' // 分享描述
        };
        that.weixin.GetshareWechatMessage(_config).then(data=>{
          that.msg.Alert("转发成功");
  
        }).catch(err=>{
          that.msg.Alert(err.ResponseMessage.ErrorMessage);
        });
    }
  }
  /**
   * 如果 SNC二维码不存在就请求此接口调用
   */
  SNCInfo(){
    const that=this;
    let body = new WebParameterContext();
    body.ConfigName = "SNCQrcodeManage";
    body.OpType = "add";
    body.ConfigType = "form";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = 1;
    body.Client.PageName = "ScanCodeSales";
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    that.msg.Loading("二维码生成中，请稍后...").then(load=>{
      that.http.post(app.DEFAULTURL, body).then(
        data => {
          load.dismiss();
          if(data.ResponseMessage.Success){
            console.log(data,"结果");
            that.comon.setHistoryUrl();
            let urlInfo:any = data.Status.Datas[0].QR;
            console.log("&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&");
            console.log(data.Status.Datas.length);
            if(data.Status.Datas.length>1){
              that.msg.Alert("未查询到巢妈团二维码，请联系客服");
              return;
            }
            if(urlInfo){
              let userinfo:SysAccount = that.comon.GetAccount;
              userinfo.Qrcode=urlInfo;
              localStorage.setItem("account",JSON.stringify(userinfo));
              let _imgurl:any = urlInfo.replace("/placeholder","");
              let _url:any=app.WEBURL+"/"+_imgurl;
              sessionStorage.setItem("curl","true");
              that.comon.goQrCode(_url,"ismycode");
            }else{
               that.msg.Alert("未查询到巢妈团二维码，请联系客服");
            }
           
          }else{
            that.msg.Alert(data.ResponseMessage.ErrorMessage);
          }
        }
      ).catch(error => {
        load.dismiss();
        that.msg.Alert(error.ResponseMessage.ErrorMessage);
        console.log(error);
      });
      load.present();
    });
  }
  SNCInfo1(){
    const that=this;
    let body = new WebParameterContext();
    body.ConfigName = "SNCQrcodeManage";
    body.OpType = "QUERY";
    body.ConfigType = "form";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = 1;
    body.Client.PageName = "ScanCodeSales";
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    that.msg.Loading("二维码生成中，请稍后...").then(load=>{
      that.http.post(app.DEFAULTURL, body).then(data => {
          load.dismiss();
          if(data.ResponseMessage.Success){
            data.Status=data.Status||[{},{}];
            if(data.Status.length>1){
              that.msg.Alert("未查询到巢妈团二维码，请联系客服");
              return;
            }
            console.log(data,"结果");
            that.comon.setHistoryUrl();
            let urlInfo:any = data.Status[0].qrcode_url;
            if(urlInfo){
              let userinfo:SysAccount = that.comon.GetAccount;
              userinfo.Qrcode=urlInfo;
              localStorage.setItem("account",JSON.stringify(userinfo));
              let _imgurl:any = urlInfo.replace("/placeholder","");
              let _url:any=app.WEBURL+"/"+_imgurl;
              sessionStorage.setItem("curl","true");
              that.comon.goQrCodeone(_url,"ismycode");
            }else{
               that.msg.Alert("未查询到巢妈团二维码，请联系客服");
            }
           
          }else{
            that.msg.Alert(data.ResponseMessage.ErrorMessage);
          }
        }
      ).catch(error => {
        load.dismiss();
        that.msg.Alert("未查询到巢妈团二维码，请联系客服");
        console.log(error);
      });
      load.present();
    });
  }
  BtnAppweixinChat(){
    const that=this;
    if(that.comon.IsWeixinBrowser){//如果是微信
      that.weixin.selectExternalContact(0).then(res=>{
        if(res.ResponseMessage.Success){
          that.weixin.CreateopenEnterpriseChat("",res.Status[0],"").then(res=>{
            that.msg.Alert(JSON.stringify(res));
          }).catch(res=>{
            that.msg.Alert(JSON.stringify(res));
          });
        }
      }).catch(err=>{
        that.msg.Alert(JSON.stringify(err));
      })
      // that.weixin.getCurExternalContact().then(res=>{
      //   if(res.Status[0]){
      //     that.weixin.CreateopenEnterpriseChat('',res.Status[0],'').then(res=>{
      //       console.log(res,"会话成功");
      //       that.msg.Alert("会话成功");
      //     }).catch(res=>{
      //       that.msg.Alert(res.ResponseMessage.ErrorMessage);
      //       console.log(res,"会话失败");
      //     });
      //   }
      // }).catch(res=>{
      //   console.log(JSON.stringify(res));
      //   that.msg.Alert(res.ResponseMessage.ErrorMessage);
      //   console.log(res,"会话异常");
      // });

    }
  }
  BtnAppweixinChat2(){
    const that =this;
    that.http.RequestWXAuthorization().then(data => {
      let  wxfg:any = data.Status.agentConfig||{};
      //通过agentConfig注入应用的权限
     let _agentConfig:AgentConfigParams={
         Corpid:wxfg.corpid, // 必填，企业微信的corpid，必须与当前登录的企业一致
         Agentid:wxfg.agentid, // 必填，企业微信的应用id
         Timestamp:wxfg.timestamp , // 必填，生成签名的时间戳
         NonceStr:wxfg.nonceStr, // 必填，生成签名的随机串
         Signature:wxfg.signature,// 必填，签名，见附录1
         JsApiList:wxfg.jsApiList //必填
     };
     console.log(_agentConfig.JsApiList);
     that.comon.AgentConfigWechat(_agentConfig).then(data => {
      console.log(data, "授权成功");

    //   wx.invoke('sendChatMessage', {
    //     msgtype:"text", //消息类型，必填
    //     enterChat: true, //为true时表示发送完成之后顺便进入会话，仅移动端3.1.10及以上版本支持该字段
    //     text: {
    //         content:"如果产品使用过程中遇到冲调问题可随时找我哦～", //文本内容
    //     },
    //     image:
    //     {
    //         mediaid: "", //图片的素材id
    //     },
    //     // video:
    //     // {
    //     //     mediaid: "", //视频的素材id
    //     // },
    //     // file:
    //     // {
    //     //    mediaid: "", //文件的素材id
    //     // },
    //     // news:
    //     // {
    //     //     link: "", //H5消息页面url 必填
    //     //     title: "", //H5消息标题
    //     //     desc: "", //H5消息摘要
    //     //     imgUrl: "", //H5消息封面图片URL
    //     // },
    //     // miniprogram:
    //     // {
    //     //     appid: "wx8bd80126147df384",//小程序的appid
    //     //     title: "this is title", //小程序消息的title
    //     //     imgUrl:"https://search-operate.cdn.bcebos.com/d054b8892a7ab572cb296d62ec7f97b6.png",//小程序消息的封面图。必须带http或者https协议头，否则报错 $apiName$:fail invalid imgUrl
    //     //     page:"/index/page.html", //小程序消息打开后的路径，注意要以.html作为后缀，否则在微信端打开会提示找不到页面
    //     // },
    // }, function(res) {
    //     if (res.err_msg == 'sendChatMessage:ok') {
    //       that.msg.Alert("发送成功");
    //         //发送成功
    //     }
    // })
      try{
        that.weixin.getCurExternalContact().then(res=>{
          that.msg.Alert(JSON.stringify(res));

      

        }).catch(res=>{
          that.msg.Alert(JSON.stringify(res));
        });
      }catch{}
     
      // weixin.invoke('navigateToAddCustomer', {

      // },function(res) {
      //   console.log(res,"返回的参数zora");
      //  });

    
  }).catch(err => {
    
      console.log(err, "授权操作失败");
      // console.log(newcontent)
  });

    
    }).catch(err => {
        
      console.log(err, "授权操作失败3333");
  });
       
      
   
  }
}



